import axios from 'axios'
import { backendUrl } from '../../config/config'

const saveSettings = async (generalSettings) => {
    const result = await axios.put(`${backendUrl}/api/generalSettings`, generalSettings)
    return result.data;
}


const getSettings = async () => {
    const result = await axios.get(`${backendUrl}/api/generalSettings`)
    return result.data
}

export {
    saveSettings,
    getSettings
}
  